<form [formGroup]="selectFormGroup" *ngIf="confidentialityLevels">
  <mat-form-field floatPlaceholder="never">
    <mat-select
      hideSingleSelectionIndicator="true"
      id="confidentialityFC"
      formControlName="confidentialityFC"
      disableOptionCentering
    >
      <mat-option *ngFor="let level of confidentialityLevels" [value]="level">
        {{ level.value }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
